import { useEffect } from 'react';
import {
    Button,
    Grid,
    Typography,
    Alert,
    Box,
    useTheme
} from '@mui/material';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { getProjects } from '../../actions/forms';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '../../actions/auth';
import CFDashboard from '../apps/carbonfootprinting/dashboard/CFDashboard';
import ClickEmoji from '../shared-components/emojis/ClickEmoji';
import ProjectCard from '../shared-components/ProjectCard';
import TCDashboard from '../apps/tigercatburns/dashboard/TCDashboard';
import BannerHeader from '../apps/rofburns/shared-components/BannerHeader';

const Home = ({ userType, isOpen }) => {
    const { isBiocharOrConservationBurnUser, isCarbonFootprintUser, isTigercatBurnsUser } = userType
    const dispatch = useDispatch();
    const navigate = useNavigate()


    const theme = useTheme()

    const { userData } = useSelector(state => state.auth);
    const { projects } = useSelector(state => state.postFormData)


    // useEffect(() => {
    //   if (carRppbProjects?.length > 0 && !activeCarRppbProject) {
    //     setActiveCarRppbProject(carRppbProjects[0]);
    //   }
    // }, [carRppbProjects, activeCarRppbProject]);



    useEffect(() => {
        dispatch(getUserDetails());
    }, [dispatch]);

    useEffect(() => {
        if (userData)
            if (
                userData &&
                userData.farmId &&
                !userData.carbonFootprintUser &&
                !userData.tigercatBurnsUser
            ) {
                dispatch(getProjects(userData.farmId));
            }
    }, [dispatch, userData?.farmId]);

    const handleNavigate = (project) => {
        navigate(`/project/${project.id}?nickname=${project.nickname}&projectIdentifier=${project.projectId}`)
    }

    const renderHomeContent = () => {
        if (isBiocharOrConservationBurnUser)
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <BannerHeader >
                        Home
                    </BannerHeader>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Typography variant='h5' >
                                    Welcome to the CHARR app!
                                </Typography>
                                <Typography sx={{ color: '#212746', fontWeight: 'bold' }}>
                                    Click <ClickEmoji /> on the button below to access the CHARR data capturing section.
                                </Typography>
                            </Box>
                            <Box>
                                <Button
                                    variant="contained"
                                    sx={{ width: 'fit-content' }}
                                    onClick={() => navigate('/programs')}>
                                    CHARR Tool
                                </Button>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Typography variant="h5" component="h5">
                                    Project Shortcuts
                                </Typography>
                                <Typography>
                                    Clicking on a card below will grant you quick access to the associated project.
                                </Typography>
                            </Box>
                            <Grid item xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'}>
                                <ProjectCard projects={projects} handleNavigate={handleNavigate} variant='link' />
                            </Grid >
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Alert severity='info' sx={{ display: 'flex', width: 'fit-content' }}>
                                Please email <b style={{ textDecoration: 'underline' }}>wihan@mycharr.app</b> if you need any further assistance or supporting documentation, including:
                                <Box component='ul' py={0} px={3}>
                                    <Box component='li' sx={{ '::marker': { color: theme.palette.info.main }, pt: 1 }}>Web App User Manual</Box>
                                    <Box component='li' sx={{ '::marker': { color: theme.palette.info.main } }}>CHARR Mobile App Field Guide</Box>
                                    <Box component='li' sx={{ '::marker': { color: theme.palette.info.main } }}>Biochar Toolkit Overview</Box>
                                    <Box component='li' sx={{ '::marker': { color: theme.palette.info.main } }}>Tips for Data Quality Improvements</Box>
                                </Box>
                            </Alert>
                        </Box>
                        {/* {console.log(userData)} */}
                    </Box>
                </Box>
            )
        else if (isCarbonFootprintUser)
            return (
                <CFDashboard userData={userData} isOpen={isOpen} />
            )
        else if (isTigercatBurnsUser)
            return (
                <TCDashboard userData={userData} isOpen={isOpen} />
            )
    }

    return (
        <>
            {renderHomeContent()}
        </>
    );
};

export default Home